/**
 * Input Schema of OcorrenciaTrackingResponsavel
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {TipoVeiculo} from '@/model/resource/TipoVeiculo'

/* TODO: review generated schema */
export class InputTipoVeiculoSchema extends Schema {
  readonly name = 'InputTipoVeiculo'

  readonly fieldSet: FieldSet<TipoVeiculo> = {
    idTipoVeiculo: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        maxlength: 11,
        step: 1,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
        inputClass: 'uppercase',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
